import { NgModule } from '@angular/core';
import { MeesageErrorFormComponent } from './meesage-error-form.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [MeesageErrorFormComponent],
  exports: [MeesageErrorFormComponent],
  imports: [CommonModule],
})
export class MeesageErrorFormModule {}
